import React, {useEffect, useState} from "react";
import { CoursesData } from "../types";
import { getCoursesPopular } from "../../service";
import {Link} from "react-router-dom";
import { priceConvert } from "../../units";


type Popular = Array<CoursesData>

function OnlineCourse(){

    const [popular,setPopular] = useState<Popular>([])

    useEffect(()=> {
        getCoursesPopular().then(res => {
            if(res.code === 1){
                setPopular(res.data)
            }
        })
    },[])

    return <div className="online">
            {
                popular.map((item,index:number) => {
                    return <Link to={`/course/${item.id}/detail`} className="ke" key={index}>
                        <div className="img-box">
                            <div className="img-bg" style={{ backgroundImage:`url(${ item.coverUrl })` }}/>
                            {/*<img src={ item.coverUrl } alt=""/>*/}
                        </div>
                        <div className="text">
                            <p className="u">{ item.courseName } <span>￥{ priceConvert(item.coursePrice) }</span> </p>
                        </div>
                    </Link>
                })
            }
    </div>
}

export default OnlineCourse;
